<template>
  <div :class="bg ? `bg-${bg}` : 'bg-cream-deep'">
    <div class='relative overflow-hidden' :style='boxStyle'>
      <div class='container'>
        <div class='flex pt-50 pb-50 pr-50 mb-pa-0' ref='heightLeftColum' >
          <div class='w-335 mb-wp-100'>
            <h2 class='fs-32 mb-fs-28 fw-700 mb-30'>
              <slot name="title"></slot>
            </h2>
            <p class='mb-0'>
              <slot name="sub-title"></slot>
            </p>
          </div>
        </div>
      </div>
      <div class='flex mb-relative absolute top-0 mb-top-0 mb-mt-30 slide' ref='infoBox'>
        <ClientOnly>
        <transition>
          <Carousel
            :wrap-around="true"
            :itemsToShow= itemsToShow
            :autoplay='100000'
            class='inner-wrapper'
          >
            <template #counter>
            </template>
            <Slide
              class='carousel__item'
              v-for="(item,index) in listReviews" :key="index"
            >
              <div class='item tl relative w-300 mb-wp-100 pa-30 bg-white br-12 bd-1 bd-hairline'>
                <div class='absolute w-50 h-50 ntop-25 nleft-25 bd-2 bd-white br-p-50'>
                  <img v-if='item.avatar.length' :src="item.avatar" alt='' class='img-cover filter br-p-50'>
                  <div v-else class='no-img wp-100 hp-100 br-p-50'></div>
                </div>
                <div>
                  <p class='mb-10 fs-16 lh-24 fw-500 ink' v-html='item.content'></p>
                </div>
                <p class='tr mb-0 author'>
                  <span class='fs-13 fw-600 lh-18 ink'>{{item.author}}</span>
                </p>
              </div>
            </Slide>

            <template #addons>
              <Navigation class='next-prev-button' >
                  <template #prev>
                    <div class="hand"><img alt='prev' class="nav-arrow" :src="`${$assetsCdn}/icons/icon-arrow-left-large.svg`"  /></div>
                  </template>
                  <template #next>
                    <div class="hand"><img alt='next' class="nav-arrow" :src="`${$assetsCdn}/icons/icon-arrow-right-large.svg`"  /></div>
                  </template>
              </Navigation>
            </template>
          </Carousel>
        </transition>
        <template #fallback>
          <div class="carousel__item" v-for="(item, index) in listReviews" :key="index">
            <div class="item tl relative w-300 mb-wp-100 pa-30 bg-white br-12 bd-1 bd-hairline">
              <div class="absolute w-50 h-50 ntop-25 nleft-25 bd-2 bd-white br-p-50">
                <img v-if="item.avatar.length" :src="item.avatar" alt="" class="img-cover filter br-p-50" />
                <div v-else class="no-img wp-100 hp-100 br-p-50"></div>
              </div>
              <div>
                <p class="mb-10 fs-16 lh-24 fw-500 ink" v-html="item.content"></p>
              </div>
              <p class="tr mb-0 author">
                <span class="fs-13 fw-600 lh-18 ink">{{ item.author }}</span>
              </p>
            </div>
          </div>
        </template>
        </ClientOnly>
      </div>
    </div>
  </div>
</template>
<script>
import Slide from '~/components/ui/carousel/Slide'
import Carousel from '~/components/ui/carousel/Carousel'
import Navigation from '~/components/ui/carousel/Navigation'
import { PHONE, TABLET } from '~/constant/common'
import { computed, onMounted, ref } from 'vue'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'
export default {
  components: {
    Slide,
    Carousel,
    Navigation
  },
  props: {
    listReviews: {
      type: Array,
      default: null
    },
    // Section background — page passes 'cream' | 'cream-deep' (default: cream-deep).
    bg: {
      type: String,
      default: '',
      validator: (v) => ['', 'cream', 'cream-deep'].includes(v)
    },
  },
  setup() {
    const infoBox = ref(0);
    const boxStyle = ref({});
    const generalStore = useGeneralInfoStore()
    
    const windowWidth = computed(() => generalStore.generalData.windowWidth);
    const matchHeight = () => {
      if(windowWidth.value > PHONE) {
        boxStyle.value = {minHeight: infoBox.value.clientHeight + 'px'}
      }
    }

    onMounted(() => {
      matchHeight()
    })


    const itemsToShow = computed(() => {
      if(
        windowWidth.value < TABLET) {
        return 1
      }
      return 3
    });

    return {itemsToShow,PHONE, TABLET, matchHeight, infoBox, boxStyle}
  }
}
</script>
<style scoped lang='scss'>
// Carousel prev/next arrows → brand green (guideline pagination nav is #197660).
// <img> from a hardcoded external URL, so recolor via CSS filter (Technique B).
.nav-arrow {
  // solved black → $brand-green #197660 (achieved rgb(25,118,96), loss 0.037)
  filter: brightness(0) saturate(100%) invert(81%) sepia(44%) saturate(3721%) hue-rotate(111deg) brightness(47%) contrast(80%);
}
h2 {
  letter-spacing: -0.04em; // v2 display tracking (§Typography Scale L94–96)
}
.no-img {
  background: $cream-deep;
}
.filter {
  filter: drop-shadow(0px 4px 14px rgba(0, 0, 0, 0.10)); // v2 §6 — shadows are always neutral (reverted the green tint)
}
.author span {
  position: relative;
  &:before {
    content: '';
    background-color: $muted-sand;
    position: absolute;
    top: calc(50% - 2px);
    right: calc(100% + 9px);
    width: 15px;
    height: 2px;
    border-radius: $radius-pill;
  }
}

.carousel__item {
  padding: 50px 45px;
  display: block;
  @include phone {
    // Trim the desktop 50/45 padding on mobile (one card per view). Top padding reserves the
    // strip the 30px nav arrows now sit in, parked above the card (see .next-prev-button),
    // while keeping clearance for the card's -25px avatar.
    padding: 60px 25px 20px;
  }
}
.carousel__slide {
  opacity: 1;
}
.slide {
  left: calc(50% - 225px);
  max-width: 1065px;
  @media (max-width: 1300px) {
    left: calc(50% - 200px);
  }
  @media (max-width: 1199px) {
    left: 405px;
  }
  @include phone {
    left: 0;
  }
  .inner-wrapper {
    width: 100%;
    .next-prev-button {
      position: absolute;
      left: -335px;
      text-align: left;
      top: 286px;
      @include phone {
        // No left title column on mobile, so the arrows can't live beside the card.
        // Park them centered ABOVE the card, at the top of the carousel area (was
        // top:0/left:20px, which dropped them onto the card's -25px avatar and top edge).
        // Room is reserved by the extra top padding on .carousel__item below; the avatar
        // sits top-left and the arrows are centred, so the two never collide.
        top: 10px;
        bottom: auto;
        left: 0;
        right: 0;
        text-align: center;
      }
    }

  }
    :deep(.carousel) {
        .item {
            box-shadow: $shadow-sm; // §9 card — resting elevation is shadow-sm, never heavier
        }
        .carousel__slide--prev .item {
            box-shadow: none;
        }
        .carousel__prev, .carousel__next {
            position: relative;
            left: auto;
            top: auto;
            bottom: auto;
            right: auto;
            display: inline-block;
            margin-right: 30px;
        }
        @include phone {
            // arrows are centered above the card on mobile — drop the trailing gap
            // on the last one so the pair sits truly centered.
            .carousel__next { margin-right: 0; }
        }
    }
}
</style>
